import _ from 'lodash'
import { RootState } from '../../types/RootState'
import { createSelector } from '@reduxjs/toolkit'

class CompanyPlanningRecordLettersSelectors {
  getCompanyPlanningRecordLetters = (state: RootState) =>
    state.companyPlanningRecordLetters.companyPlanningRecordLetters
  getHasCompanyPlanningRecordLetters = (state: RootState) =>
    !!state.companyPlanningRecordLetters.companyPlanningRecordLetters.length
  getPaginationTimestamp = createSelector(
    [
      (state: RootState) => {
        const processedTimestamp =
          state.companyPlanningRecordLetters.companyPlanningRecordLetters[
            state.companyPlanningRecordLetters.companyPlanningRecordLetters.length - 1
          ]?.processedTimestamp
        return processedTimestamp
      },
    ],
    processedTimestamp => {
      if (processedTimestamp) {
        return new Date(processedTimestamp)
      }
    },
  )
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.companyPlanningRecordLetters.status === 'initial' ||
            state.companyPlanningRecordLetters.status === 'loading'
          : state.companyPlanningRecordLetters.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getLoadingMore = (state: RootState) =>
    state.companyPlanningRecordLetters.status === 'loading-more'
  getInitial = (state: RootState) => state.companyPlanningRecordLetters.status === 'initial'
  getHasError = (state: RootState) => state.companyPlanningRecordLetters.status === 'failed'
  getError = (state: RootState) => state.companyPlanningRecordLetters.error
}

export default new CompanyPlanningRecordLettersSelectors()
